import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {setSidebarVisible} from '../redux/slices/app.slice'

export const useMobile = (maxMobile = 790, maxSmallScreen = 1104) => {
	const [isMobile, setIsMobile] = useState(false);
	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const [currentMobileSize, setCurrentMobileSize] = useState(0);
	const dispatch = useDispatch();
	
	useEffect(() => {
		const check = () => {
			const width = window.innerWidth;
			setCurrentMobileSize(prev => {
				if (prev !== width) return width;
				return prev;
			});
			
			setIsMobile(prev => {
				const isNowMobile = width <= maxMobile;
				return prev !== isNowMobile ? isNowMobile : prev;
			});
			
			setIsSmallScreen(prev => {
				const isNowSmall = width <= maxSmallScreen;
				return prev !== isNowSmall ? isNowSmall : prev;
			});
		};
		
		check();
		window.addEventListener('resize', check);
		return () => window.removeEventListener('resize', check);
	}, [maxMobile, maxSmallScreen]);
	
	useEffect(()=>{
		dispatch(setSidebarVisible(!isSmallScreen));
	}, [isSmallScreen]);
	
	return {isMobile, isSmallScreen, currentMobileSize}
};